import Swiper from "swiper"
import { Navigation } from "swiper/modules"

import "swiper/css"
import "swiper/css/navigation"

class LsbNewsSlider extends HTMLElement {

  connectedCallback() {
    const slides = this.querySelectorAll('.swiper-slide');

    // // Check if user prefers reduced motion
    // const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (slides.length > 1) {
      const swiper = new Swiper(this.querySelector('.swiper'), {
        modules: [Navigation],
        slidesPerView: 'auto',
        speed: 600,
        allowTouchMove: true,
        navigation: {
          nextEl: '.button-next',
          prevEl: '.button-prev',
        },
        breakpoints: {
          100: {
            slidesPerView: 1.3,
            spaceBetween: 16,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 32,
          },
        },
      });
    }
  }

}


if ('customElements' in window) {
  customElements.define('lsb-news-slider', LsbNewsSlider);
}
